import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Estado 1: Cargando estado de autenticación (desde el contexto)
  // IMPORTANTE: 'loading' es false solo cuando TANTO la sesión de Supabase
  // COMO el perfil de PostgreSQL están completamente cargados
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100dvh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Estado 2: No autenticado (si no hay usuario después de cargar)
  if (!user) {
    console.log('[PrivateRoute] Usuario no encontrado, redirigiendo a login. Origen:', location);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Estado 3: Autenticado
  // console.log('[PrivateRoute] Usuario autenticado, renderizando children.');
  return children;
};

export default PrivateRoute; 